import Grid from '@material-ui/core/Grid'
import React from 'react'

export default (props) => {
  const address = props.shipment.address
  if (!address) return null
  return (
    <Grid className="text" container spacing={0}>
      <React.Fragment>
        <Grid item xs={12}>
          {address.address1}
        </Grid>
        {address.address2 && address.address2 !== '- None -' ? (
          <Grid item xs={12}>
            {address.address2}
          </Grid>) : null}
        {address.address3 && address.address3 !== '- None -' ? (
          <Grid item xs={12}>
            {address.address3}
          </Grid>) : null}
        <Grid item xs={12}>
          {address.city}, {address.state} {address.zipCode}
        </Grid>
        <Grid item xs={12}>
          {address.attention ? `Attn: ${address.attention}` : null}
        </Grid>
      </React.Fragment>
    </Grid>
  )
}
